import React from 'react';

import { getDataByModel, getTextsHeight, sliceTextWithSvgTitle } from './best-sellers.utils';
import { cymbioColors } from '../../../utils/colors';

export function BestSellersProductDescription() {
  return (canvasContext) => {
    const models = getDataByModel(canvasContext.bars);
    const barHeight = canvasContext.bars[0].height;
    const yPositions = canvasContext.bars.slice(0, Object.keys(models).length).map((bar) => bar.y);
    const [productNameHeight, productModelHeight] = getTextsHeight(barHeight, 2);

    return (
      <g x={0} y={0} height={300} width={80} transform="translate(-160 0)">
        {Object.values(models).map((value, index) => {
          const yPosition = yPositions[index];
          const { model, productName, productImage } = value;

          const productNameFragment = sliceTextWithSvgTitle(productName, 20);
          const idFragment = sliceTextWithSvgTitle(model, 17);

          return (
            <React.Fragment key={model}>
              <rect x={0} y={yPosition} height={barHeight} width={160} fill="#f6f6f6" />
              <image href={productImage} x={1} y={yPosition + 1} height={barHeight - 2} width={barHeight - 2} />
              <text
                x={barHeight + 3}
                y={yPosition + productNameHeight}
                fill={cymbioColors.analytics.textPrimary}
                fontWeight={400}
                fontFamily="Rubik, sans-serif"
                fontSize={10}
                clipPath="url(#textClip)"
              >
                {productNameFragment}
              </text>
              <text
                x={barHeight + 3}
                y={yPosition + productModelHeight}
                fill={cymbioColors.analytics.textSecondary}
                fontWeight={300}
                fontFamily="Rubik, sans-serif"
                fontSize={10}
                clipPath="url(#textClip)"
              >
                ID: {idFragment}
              </text>
            </React.Fragment>
          );
        })}
        <clipPath id="textClip">
          {[...Array(Object.keys(models).length)].map((_, index) => (
            <rect
              key={`text-clip-${index}`}
              y={yPositions[index]}
              x={barHeight}
              width={160 - barHeight - 4}
              height={barHeight}
            />
          ))}
        </clipPath>
      </g>
    );
  };
}
